import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { addOptionalService } from '../../../features/admin/additionalServiceSlice';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { OptionalServiceType } from '../../../types';



const AdditionalForm= ({additionalServices, setAdditionalServices}:{additionalServices:OptionalServiceType[],setAdditionalServices:any}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const [formData, setFormData] = useState<any>({

    title: "",
    titleAr: "",
    details: "",
    detailsAr: "",
    price:0
  });

const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  const { name, value } = e.target;

  setFormData((prev: any) => ({
    ...prev,
    [name]: name === "price" ? Number(value) : value,
  }));
};

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.title || formData.title.trim().length < 5) {
      toast.error(t("english-title-required"));
      return;
    }

    if (!formData.titleAr || formData.titleAr.trim().length < 5) {
      toast.error(t("arabic-title-required"));
      return;
    }

    if (!formData.details || formData.details.trim().length < 5) {
      toast.error(t("english-details-required"));
      return;
    }

    if (!formData.detailsAr || formData.detailsAr.trim().length < 5) {
      toast.error(t("arabic-details-required"));
      return;
    }

    if (!formData.price || formData.price <= 0) {
      toast.error(t("price-is-required"));
      return;
    }

    setLoading(true);
    try {
      const res = await dispatch(addOptionalService(formData)).unwrap();

       if (res.data) {
    setAdditionalServices((prev: any) => [...prev, res.data]);

  }
 setFormData({
        title: "",
        titleAr: "",
        details: "",
        detailsAr: "",
        price: 0
      });
    } catch (error) {
      console.error("خطأ أثناء الإرسال", error);
    } finally {
      setLoading(false);
    }
  };

  return (

    <div>

      <h3 className="text-lg font-semibold">{t("add-additional-service")}</h3>
      <form onSubmit={handleSubmit} className="flex md:flex-nowrap xs:flex-wrap gap-2 border p-2 rounded-lg">

        <input
          type="text"
          name="title"
          placeholder={t("title")}
          value={formData.title}
          onChange={handleChange}
          className="input-field "
        />
        <input
          type="text"
          name="titleAr"
          placeholder={t("titleAr")}
          value={formData.titleAr}
          onChange={handleChange}
          className="input-field "
        />
        <input
          type="text"
          name="details"
          placeholder={t("details")}
          value={formData.details}
          onChange={handleChange}
          className="input-field "
        />
        <input
          type="text"
          name="detailsAr"
          placeholder={t("detailsAr")}
          value={formData.detailsAr}
          onChange={handleChange}
          className="input-field "
        />
        <input
          type="number"
          name="price"
          placeholder={t("price")}
          value={formData.price}
          onChange={handleChange}
          className="input-field "
        />
        <button
          type="submit"
          disabled={loading}
          className="bg-secondry text-white py-2 px-4 rounded "
        >
          {loading ? t("sending") : "+"}
        </button>
      </form>

    </div>

  );
};

export default AdditionalForm;
